import type {
  customerDetailResource,
  customerResource,
} from '@porotutu/api/features/crm/customers/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { CUSTOMERS } from '@/api/keys'
import type { CrmCustomerSort } from '../vocabulary'

export type Customer = ReturnType<typeof customerResource>

export type CustomerDetail = ReturnType<typeof customerDetailResource>

export type CustomerPage = { data: Customer[]; meta: ListMeta }

export type CustomerListQuery = ListQuery<CrmCustomerSort, never>

export const customersQuery = (query: CustomerListQuery) =>
  queryOptions({
    queryKey: [...CUSTOMERS, 'list', query] as const,
    queryFn: async () => unwrap(await crm.customers.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const customerQuery = (id: string) =>
  queryOptions({
    queryKey: [...CUSTOMERS, 'record', id] as const,
    queryFn: async () => unwrap(await crm.customers({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<CustomerListQuery>('/api/v1/crm/customers/export', {
  always: [],
  viewed: ['search'],
})
